import React, { useState, useEffect, useRef } from 'react';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
function SupplierCostPage({InvoiceID}) {
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    
                </div>
            </div>
        </div>
    );
}

export default SupplierCostPage;
